import QuestionsRouter from './Questions.router';
export { default as questionsRoutes } from './routes';

export default QuestionsRouter;
